import { Component, EventEmitter, Output } from '@angular/core';
import { timer } from 'rxjs';
import { StagingFromBackupModalComponent } from '../../../staging-from-backup/staging-from-backup-modal/staging-from-backup-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-staging-desc-card',
  templateUrl: './staging-desc.component.html',
  styleUrls: ['./staging-desc.component.scss'],
  standalone: false,
})
export class StagingDescComponent {
  @Output() createRequest = new EventEmitter<null>();
  disableButton = false;

  constructor(private dialog: MatDialog) {}

  createStaging(): void {
    this.disableButton = true;
    this.createRequest.emit(null);
    timer(10000).subscribe(() => (this.disableButton = false));
  }

  createStagingFromBackup(): void {
    this.disableButton = true;
    this.dialog
      .open(StagingFromBackupModalComponent, {
        panelClass: ['staging-from-backup-modal'],
        minWidth: '800',
        width: '800',
        height: '600',
      })
      .afterClosed()
      .subscribe((resetting: boolean) => {
        if (resetting) {
          window.setTimeout(() => {
            this.disableButton = false;
          }, 10000);
        } else {
          this.disableButton = false;
        }
      });
  }
}
